import { render, staticRenderFns } from "./DrChronoAccount.vue?vue&type=template&id=70011952&scoped=true&"
import script from "./DrChronoAccount.vue?vue&type=script&lang=js&"
export * from "./DrChronoAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70011952",
  null
  
)

export default component.exports